import AdultScheduledGigsWorkspace from "../../../components/scheduled-gigs/AdultScheduledGigsWorkspace";

const AdultScheduledGigsPage = () => {
  return <AdultScheduledGigsWorkspace />;
};

export default AdultScheduledGigsPage;
